import request from '@/services/interceptor.js'


export const get_userInfo = () => {
  return request({
    url: '/api/users/info',
    method: 'get'
  })
};

export const get_profiloUtente = (par) => {
  return request({
    url: '/api/users/profilo/' + par,
    method: 'get'
  })
};

export const save_userAccount = par => {
  return request({
    url: '/api/users/account/save',
    method: 'post',
    data: par
  })
};

export const get_statoMenu = (par) => {
  return request({
    url: '/api/users/stato/' + par,
    method: 'get'
  })
};